import { Component, Input, OnChanges, OnDestroy } from '@angular/core';
import { Subscription, forkJoin } from 'rxjs';
import { DiagnosisDetail, TriageHistory } from '../../models/patientHealth';
import { PatientHealthService } from '../../services/patient-health.service';
import {
  formatBloodPressure,
  formatBloodPressureGroup,
  formatTriageAnswer,
  heightInCm
} from '../../utils/patient-health.utils';

/** Vitais, triagem e análise de sintomas do paciente, ao lado da chamada. */
@Component({
  selector: 'app-patient-health-panel',
  templateUrl: './patient-health-panel.component.html'
})
export class PatientHealthPanelComponent implements OnChanges, OnDestroy {
  @Input({ required: true }) userId!: string;
  @Input() patientName = '';

  loading = false;
  triage: TriageHistory | null = null;
  diagnosis: DiagnosisDetail | null = null;

  // Datas chegam em UTC; o atendimento é exibido no horário de Brasília (sem horário de verão desde 2019).
  readonly brasiliaOffset = '-0300';

  readonly formatBloodPressure = formatBloodPressure;
  readonly formatBloodPressureGroup = formatBloodPressureGroup;
  readonly formatTriageAnswer = formatTriageAnswer;
  readonly heightInCm = heightInCm;

  private subscription?: Subscription;

  constructor(private readonly patientHealthService: PatientHealthService) {}

  ngOnChanges(): void {
    this.subscription?.unsubscribe();
    this.loading = true;
    this.triage = null;
    this.diagnosis = null;

    this.subscription = forkJoin({
      triage: this.patientHealthService.getTriage(this.userId),
      diagnosis: this.patientHealthService.getLatestDiagnosis(this.userId)
    }).subscribe(({ triage, diagnosis }) => {
      this.triage = triage;
      this.diagnosis = diagnosis;
      this.loading = false;
    });
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  isFromToday(date: string): boolean {
    return new Date(date).toDateString() === new Date().toDateString();
  }
}
